import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Nyhet: WordPress‑integration i Controla",
  header: "Nyhet: WordPress‑integration i Controla",
  date: "2025-12-09",
  description:
    "Koppla din WordPress‑sajt till Controla för att skanna inställningar, blockera vanliga risker och göra 2FA till standard.",
  category: "säkerhet",
  draft: false,
  authorKey: "agnes_onne",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
